import { mergeAttributes, Node } from '@tiptap/core'

/* Stores only the questionnaire's canonical URL — the response is resolved at
 * render time. Nothing routes CarePlan.description through the server renderer
 * today, but the node lives in the shared editor schema and so can be pasted
 * into a visit note. */
export const CarePlanQuestionnaireNode = Node.create({
  name: 'care-plan-questionnaire',
  group: 'block',
  atom: true,
  /* Hosts interactive per-item forms; not node-selectable for the same reason
   * as ValidatedToolNode. */
  selectable: false,
  addAttributes() {
    return {
      questionnaireUrl: {
        default: null,
        parseHTML: (element: HTMLElement) =>
          element.getAttribute('data-questionnaire-url'),
        renderHTML: (attributes: Record<string, string>) =>
          attributes.questionnaireUrl
            ? { 'data-questionnaire-url': attributes.questionnaireUrl }
            : {},
      },
    }
  },
  parseHTML() {
    return [{ tag: `div[data-type="${this.name}"]` }]
  },
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-type': this.name,
        contentEditable: 'false',
      }),
    ]
  },
})
